import React, { useRef } from "react";
import { Modal, Button, Row, Col, Card } from "react-bootstrap";
import QRCode from "qrcode.react";
import configs from "../config.json";

const GuestTicketModal = ({
  show,
  onHide,
  reservation,
  onPurchaseComplete,
  phoneNo,
  email,
  fullname,
  applicationNumber,
  transactionCost,
}) => {
  if (!reservation) return null;
  const ticketCanvasRef = useRef();
  const url = configs.frontendURL + "/ticket/" + reservation._id;

  const handlePrint = () => {
    const printWindow = window.open("", "_blank", "width=600,height=800");
    if (printWindow) {
      printWindow.document.write(`
      <html>
        <head>
          <title>Print Ticket</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 40px; text-align: center; }
            .qr { margin: 30px 0; }
            .info { margin-bottom: 20px; font-size: 18px; }
            h2 { margin-bottom: 10px; }
          </style>
        </head>
        <body>
          <h2>Ticket</h2>
          <div class="info">
            <div><b>Reference No:</b> ${applicationNumber}</div>
            <div><b>Name:</b> ${fullname}</div>
            <!-- Removed Email and Phone for privacy -->
            <div><b>From:</b> ${reservation.from} <b>To:</b> ${
        reservation.to
      }</div>
            <div><b>Date:</b> ${reservation.date} <b>Time:</b> ${
        reservation.time
      }</div>
            <div><b>Class:</b> ${reservation.trainClass}</div>
            <div><b>Quantity:</b> ${reservation.qty}</div>
            <div><b>Total:</b> ${(Number(reservation.total) || 0).toFixed(
              2
            )} SLE</div>
          </div>
          <div class="qr">
            <img src="${document
              .getElementById("guest-qr")
              .toDataURL()}" alt="QR Code" />
          </div>
          <button onclick="window.print()">Print</button>
        </body>
      </html>
    `);
      printWindow.document.close();
    }
  };

  const drawTicketCanvas = () => {
    const canvas = ticketCanvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.fillStyle = "#0072c6";
    ctx.font = "bold 28px Arial";
    ctx.fillText("E-Ticket", 30, 50);

    ctx.fillStyle = "#222";
    ctx.font = "18px Arial";
    ctx.fillText(`Reference No: ${applicationNumber}`, 30, 90);
    ctx.fillText(`Name: ${fullname}`, 30, 120);
    // Removed Email and Phone for privacy

    // Wrap From and To on two lines
    ctx.fillText(`From: ${reservation.from}`, 30, 210);
    ctx.fillText(`To: ${reservation.to}`, 30, 235);

    ctx.fillText(
      `Date: ${reservation.date}  Time: ${reservation.time}`,
      30,
      265
    );
    ctx.fillText(`Class: ${reservation.trainClass}`, 30, 295);
    ctx.fillText(`Quantity: ${reservation.qty}`, 30, 325);
    ctx.fillText(`Payment: ${reservation.paymentMethod}`, 30, 355);
    ctx.fillText(
      `Amount:SLE ${(Number(reservation.amount) || 0).toFixed(2)} SLE`,
      30,
      385
    );
    ctx.fillText(
      `Discount: ${(Number(reservation.discount) || 0).toFixed(2)} SLE`,
      30,
      415
    );
    ctx.fillText(
      `Total:SLE ${(Number(reservation.total) || 0).toFixed(2)} SLE`,
      30,
      445
    );

    // Move QR code further right and lower
    const qrCanvas = document.getElementById("guest-qr");
    if (qrCanvas) {
      ctx.drawImage(qrCanvas, 400, 120, 128, 128);
    }
  };

  const handleSave = () => {
    drawTicketCanvas();
    const canvas = ticketCanvasRef.current;
    const pngUrl = canvas.toDataURL("image/png");
    const downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = `E-Ticket-${reservation._id}.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const handleClose = () => {
    const user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : null;
    onHide();
    setTimeout(() => {
      if (user && user.fname !== "Guest" && user.lname !== "User") {
        onPurchaseComplete();
      } else {
        window.location.reload();
      }
    }, 300);
  };

  return (
    <Modal show={show} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <span
            role="img"
            aria-label="ticket"
            style={{ fontSize: 28, marginRight: 10 }}
          >
            🎫
          </span>
          <span style={{ fontWeight: "bold", fontSize: 22, color: "#0072c6" }}>
            Your E-Ticket
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ textAlign: "center", marginBottom: 16 }}>
          <span style={{ fontSize: 18, fontWeight: 600, color: "#0072c6" }}>
            Show this QR code at the terminal to board
            <br />
            <span style={{ fontSize: 18, fontWeight: 600, color: "#f13607ff" }}>
              Please make sure you have completed your payment, as scanning will
              fail otherwise.
            </span>
          </span>
        </div>
        <Card style={{ padding: 10, marginBottom: 10 }}>
          <Row>
            <Col>
              Reference No: <b>{applicationNumber}</b>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col>
              <Row>
                <Col>
                  <b>Name:</b> {fullname}
                </Col>
              </Row>
              {/* Removed Email and Phone Number rows for privacy */}
              <Row>
                <Col>
                  From <b>{reservation.from}</b> to <b>{reservation.to}</b>
                </Col>
              </Row>
              <Row>
                <Col>
                  <b>
                    {reservation.date} {reservation.time}
                  </b>
                </Col>
              </Row>
              <Row>
                <Col>
                  Transport Mode: <b>{reservation.train}</b>
                </Col>
              </Row>
              <Row>
                <Col>
                  Class: <b>{reservation.trainClass}</b>
                </Col>
              </Row>
              <Row>
                <Col>
                  Quantity: <b>{reservation.qty}</b>
                </Col>
              </Row>
            </Col>
            <Col
              align="right"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <QRCode id="guest-qr" value={url} size={128} />
            </Col>
          </Row>
          <hr />
          <Row>
            <Col>
              Payment Method: <b>{reservation.paymentMethod}</b>
            </Col>
          </Row>
          <Row>
            <Col>
              Amount: SLE <b>{(Number(reservation.total) || 0).toFixed(2)}</b>
            </Col>
            {/* Transaction Cost hidden by request; total still includes it */}
            <Col align="right">
              <b>Total: SLE </b>{" "}
              <b>{(Number(reservation.total) || 0).toFixed(2)}</b>
            </Col>
          </Row>
        </Card>

        <div style={{ textAlign: "right" }}>
          <Button
            variant="primary"
            onClick={handlePrint}
            style={{ marginRight: 8 }}
          >
            Print E-Ticket
          </Button>
          <Button
            variant="success"
            onClick={handleSave}
            style={{ marginRight: 8 }}
          >
            Save
          </Button>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </div>
      </Modal.Body>
      <canvas
        ref={ticketCanvasRef}
        width={600}
        height={500}
        style={{ display: "none" }}
      />
    </Modal>
  );
};

export default GuestTicketModal;
